var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{ref:"result-list",staticClass:"result-list",on:{"click":_vm.onResultClick}},_vm._l((_vm.list),function(location,idx){return _c('li',{key:location,class:[
      'result-list-item',
      { active: idx === _vm.focusedIdx }
    ],attrs:{"data-location":location}},[_vm._v(" "+_vm._s(location)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }